import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveCoverage } from './selectors';
import { filterCurrentlyActiveCoverage } from './coverageEffectiveNow';

/** Re-evaluate date window periodically so expiry/start mid-session is reflected without relying on Redux refetches. */
const COVERAGE_TIME_TICK_MS = 60_000;

/**
 * Task coverage rows whose [startDate, endDate] includes the current time. Not memoized with `createSelector`
 * (time is not Redux state); subscribe to raw coverage here and re-filter on interval + tab visibility.
 */
export function useActiveCoverageForTaskActions() {
  const raw = useSelector(selectActiveCoverage);
  const [tick, setTick] = useState(0);

  const bump = useCallback(() => setTick(t => t + 1), []);

  useEffect(() => {
    const id = window.setInterval(bump, COVERAGE_TIME_TICK_MS);
    return () => window.clearInterval(id);
  }, [bump]);

  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === 'visible') bump();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [bump]);

  return useMemo(() => filterCurrentlyActiveCoverage(raw), [raw, tick]);
}
